// 출생지 → 위경도. 사주·점성·베딕·인물관리 공용.
export const CITIES: { name: string; lat: number; lon: number }[] = [
  { name: "서울특별시", lat: 37.5665, lon: 126.978 }, { name: "부산광역시", lat: 35.1796, lon: 129.0756 },
  { name: "인천광역시", lat: 37.4563, lon: 126.7052 }, { name: "대구광역시", lat: 35.8714, lon: 128.6014 },
  { name: "대전광역시", lat: 36.3504, lon: 127.3845 }, { name: "광주광역시", lat: 35.1595, lon: 126.8526 },
  { name: "울산광역시", lat: 35.5384, lon: 129.3114 }, { name: "수원시", lat: 37.2636, lon: 127.0286 },
  { name: "춘천시", lat: 37.8813, lon: 127.7298 }, { name: "강릉시", lat: 37.7519, lon: 128.8761 },
  { name: "청주시", lat: 36.6424, lon: 127.489 }, { name: "전주시", lat: 35.8242, lon: 127.148 },
  { name: "포항시", lat: 36.019, lon: 129.3435 }, { name: "창원시", lat: 35.2281, lon: 128.6811 },
  { name: "제주시", lat: 33.4996, lon: 126.5312 },
];

// 좌표/도시명 → CITIES 인덱스(저장된 위치 복원)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function cityIdxFor(b: any): number {
  if (b?.cityLabel) { const i = CITIES.findIndex((c) => c.name === b.cityLabel); if (i >= 0) return i; }
  let best = 0, bd = Infinity;
  CITIES.forEach((c, i) => { const d = Math.abs(c.lat - (b?.lat ?? 0)) + Math.abs(c.lon - (b?.lon ?? 0)); if (d < bd) { bd = d; best = i; } });
  return best;
}
